export default [
	{
		path: '/', //首页
		meta: {
			title: '卡片绑定'
		},
		component: () => import('@/views/home/index'),
	},
	{
		path: '/personNew', //首页
		meta: {
			title: '卡片信息'
		},
		component: () => import('@/views/person/index'),
	},
	{
		path: '/lesson', //首页
		meta: {
			title: '教辅材料'
		},
		component: () => import('@/views/lesson/index'),
	},
	{
		path: '/manual', //首页
		meta: {
			title: '使用手册'
		},
		component: () => import('@/views/manual/index'),
	},
	{
		path: '/manualDetail', //首页
		meta: {
			title: '使用手册'
		},
		component: () => import('@/views/manual/detail'),
	},
	{
		path: '/questionnaire', //首页
		meta: {
			title: '调查问卷'
		},
		component: () => import('@/views/questionnaire/index'),
	},
	{
		path: "/upload", //首页
		meta: {
			title: "课程列表",
		},
		component: () => import("@/views/lesson/upload"),
	},
	{
		path: "/homework", //首页
		meta: {
			title: "今日作业",
		},
		component: () => import("@/views/homework/index"),
	},
	{
		path: "/myCenter", //首页
		meta: {
			title: "个人中心",
		},
		component: () => import("@/views/center/index"),
	},
	{
		path: '/analysis', //首页
		redirect: '/analysis/all',
		meta: {
			title: '学情分析'
		},
		component: () => import('@/views/analysis/index'),
		children: [
			{
				path: '/analysis/all',
				name: 'All',
				meta: {
					title: "学情分析",
				},
				component: () => import('@/views/analysis/all.vue')
			},
			{
				path: '/analysis/newSubject',
				name: 'NewSubject',
				meta: {
					title: "学情分析",
				},
				component: () => import('@/views/analysis/newSubject.vue')
			}
		]
	},
	{
		path: '/analysis/point',
		name: 'Point',
		meta: {
			title: "学情分析",
		},
		component: () => import('@/views/analysis/point.vue')
	},
	{
		path: '/analysis/subject',
		name: 'Subject',
		meta: {
			title: "学情分析",
		},
		component: () => import('@/views/analysis/subject.vue')
	}
];



// WEBPACK FOOTER //
// ./src/router/modules/home.js